import { useEffect } from "react";
import { toast } from "react-toastify";
import { useFetch } from "utils/hooks";

import { useQuery } from "@tanstack/react-query";

import { Urls } from "../../urls.ts";

import { EquipmentResponse } from "./type.ts";

type useEquipmentParams = {
  startDate?: string | null;
  endDate?: string | null;
};

const useEquipment = (params: useEquipmentParams) => {
  const { startDate, endDate } = params;

  const fetch = useFetch();

  const {
    data,
    isLoading: isFetching,
    isError,
  } = useQuery<EquipmentResponse | null, Error, EquipmentResponse>({
    queryKey: ["equipment", startDate, endDate],
    enabled: !!(startDate && endDate),
    queryFn: () =>
      fetch<EquipmentResponse>(`${Urls.Equipment}?startDate=${startDate}&endDate=${endDate}`, {
        method: "GET",
      }),
    gcTime: 0,
    staleTime: 0,
  });

  useEffect(() => {
    if (isError) {
      toast.error("Error getting equipment");
    }
  }, [isError]);

  return {
    equipment: data?.equipments || [],
    isFetching,
  };
};

export default useEquipment;
